import React from "react";
import { useNavigate } from "react-router-dom";

const CustomErrorPage: React.FC = () => {
  const navigate = useNavigate();

  const handleReload = () => {
    window.location.reload();
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--color-fourth)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 8px 40px rgba(0, 0, 0, 0.14)",
          padding: "2.5rem 1.5rem 2rem 1.5rem",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Icon Circle */}
        <div
          style={{
            background: "var(--color-primary)",
            borderRadius: "50%",
            width: 64,
            height: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 18,
          }}
        >
          <svg width="36" height="36" fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" fill="#fff" />
            <path
              d="M12 16v-4M12 8h.01"
              stroke="var(--color-primary)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Title */}
        <h1
          style={{
            color: "var(--color-primary)",
            fontWeight: 700,
            fontSize: "1.6rem",
            margin: "0 0 0.5rem 0",
            fontFamily: "var(--font-heading)",
          }}
        >
          Oops! Something went wrong
        </h1>

        {/* Description */}
        <p
          style={{
            color: "#444",
            fontSize: "1.08rem",
            margin: "0 0 1.5rem 0",
            lineHeight: 1.6,
            fontFamily: "var(--font-body)",
          }}
        >
          We couldn’t load this page.
          <br />
          Please check your connection or try again.
        </p>

        {/* Reload Button */}
        <button
          onClick={handleReload}
          style={{
            background: "var(--color-primary)",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "0.7rem 2.2rem",
            fontSize: "1.1rem",
            fontWeight: 600,
            cursor: "pointer",
            marginBottom: 12,
            width: "100%",
            maxWidth: 220,
            transition: "background 0.2s",
            fontFamily: "var(--font-body)",
          }}
        >
          Reload Page
        </button>

        {/* Go Home Button */}
        <button
          onClick={handleBack}
          style={{
            background: "#fff",
            color: "var(--color-primary)",
            border: "1.5px solid var(--color-primary)",
            borderRadius: 8,
            padding: "0.7rem 2.2rem",
            fontSize: "1.1rem",
            fontWeight: 600,
            cursor: "pointer",
            width: "100%",
            maxWidth: 220,
            transition: "background 0.2s, color 0.2s",
            fontFamily: "var(--font-body)",
          }}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default CustomErrorPage;
